export default{
  //baseURL:'http://www.vatunion.com:19882/ei',
  baseURL:'https://inv.taxunion.com.cn:8192/ei/',
  h5URL:'https://www.yuncaikeji.net.cn/h5/#/?id=',
  hrefurl:"https://www.yuncaikeji.net.cn/monitor/#/login",
  title:"智能财税共享中心",
  englishtitle:"E-invoice Platform",
  beianhao:"沪ICP备17025516号-2",
  img:"tax_t.png",
  projectName: "PRODUCT",
  //是否开启产品的单点登录
  enableFamilyLogin: true,
  //产品门户网站地址
  familyLoginUrl: "https://all.taxunion.com.cn/#/Homepage"
}
